import { render } from "./AddNewCardButton.vue?vue&type=template&id=942232ce"
import script from "./AddNewCardButton.vue?vue&type=script&lang=js"
export * from "./AddNewCardButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__